export default __webpack_public_path__ + "static/tire-logo-full-42d18340bf4b47c8d56f9f9fe0639504.png";